"use strict";
import "polyfill";
import controllerF from 'controller/contact';
import view from 'view/contact';

controllerF(
    document.getElementById('contact'),
    view
).exec();